import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import icGroup from '@iconify/icons-ic/twotone-group';
import { ApexOptions } from 'src/@vex/components/chart/chart.component';
import { createDateArray } from 'src/@vex/utils/create-date-array';
import { defaultChartOptions } from 'src/@vex/utils/default-chart-options';
import { Constantes } from 'src/app/models/modules/Constantes';
import { AutenticacionService } from 'src/app/services/autenticacion.service';
import { ConfiguracionInicialService } from 'src/app/services/configuracioninicial.service';
import { MenuService } from 'src/app/services/menu.service';
import { ProductosService } from 'src/app/services/productos.service';
import { UtilitariosService } from 'src/app/services/utilitarios.service';
import { TamanoAppService } from '../../services/tamanoapp.service';
import { ProductosResumenUsuarioMes } from '../../models/generic/ProductosResumenUsuarioMes';

@Component({
  selector: 'globalresumenasistencias',
  templateUrl: './globalresumenasistencias.component.html',
  styleUrls: ['./globalresumenasistencias.component.scss']
})
export class GlobalresumenasistenciasComponent implements OnInit{
  mostrarCargando: boolean = true;

  constructor(public router: Router,
    public fb: FormBuilder,
    public cd: ChangeDetectorRef,
    public snackbar: MatSnackBar,
    public utilitariosService: UtilitariosService,
    public configuracionInicialService: ConfiguracionInicialService,
    public autenticacionService: AutenticacionService,
    public menuService: MenuService,
    public productosService: ProductosService,
    public tamanoAppService: TamanoAppService) {}

    ngOnInit() {
      if (this.autenticacionService.EstaAutenticado()) {
        this.cargarResumen();

        this.productosService.NotificarCambiarResumen.subscribe((cambiarResumen: boolean) => {
          if (cambiarResumen) {
            this.cargarResumen();
          }
        });
      }
    }

    cargarResumen() {
      this.mostrarCargando = true;
      if (this.configuracionInicialService.ConfigLocal.TomarArchivosLocales) {
        this.configuracionInicialService.ObtenerConfiguracion(Constantes.CONFIGURACIONLOCAL_RESUMEN())
          .subscribe((resp: ProductosResumenUsuarioMes[]) => {
            this.continuarCargarResumen(resp);
          },
          (error: Error) => {
            this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
            this.mostrarCargando = false;
            this.cd.detectChanges();
          },
          () => this.cd.detectChanges());
      } else {
        let formConsulta = this.fb.group({
          idAplicacion: 0,
          canal: ''
        });
        formConsulta.get('idAplicacion').setValue(this.autenticacionService.AplicacionSeleccionadoInicial);
        formConsulta.get('canal').setValue(this.autenticacionService.DescripcionCanalSeleccionadoInicial);
        this.productosService.CargarProductosResumenUsuarioMes(formConsulta.value).subscribe((resp: ProductosResumenUsuarioMes[]) => {
          this.continuarCargarResumen(resp);
        },
        (error: Error) => {
          this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
          this.mostrarCargando = false;
          this.cd.detectChanges();
        },
        () => this.cd.detectChanges());
      }
  }

  continuarCargarResumen(resp: ProductosResumenUsuarioMes[]) {
    this.productosService.ListaProductosResumenUsuarioMes = resp;
    this.mostrarCargando = false;

    if (this.utilitariosService.VerificarContieneDatosLista(this.productosService.ListaProductosResumenUsuarioMes)) {
      this.productosService.CantidadDiaria = this.productosService.ListaProductosResumenUsuarioMes[0].asistenciasHoy;
      this.productosService.CantidadSemanal = this.productosService.ListaProductosResumenUsuarioMes[0].asistenciasSemana;
      this.productosService.CantidadMensual = this.productosService.ListaProductosResumenUsuarioMes[0].asistenciasMes;
      this.productosService.CantidadEsperadaDiaria = this.productosService.ListaProductosResumenUsuarioMes[0].asistenciaEsperadaHoy;
      this.productosService.CantidadEsperadaSemanal = this.productosService.ListaProductosResumenUsuarioMes[0].asistenciaEsperadaSemana;
      this.productosService.CantidadEsperadaMensual = this.productosService.ListaProductosResumenUsuarioMes[0].asistenciaEsperadaMes;
    }
  }
}
